import React from 'react';
import { useAppOriginParam } from '../hooks/useValidate';
import { Ads } from '../components/shared/Ads';
import { Col } from 'react-bootstrap';
import { GetStartedEmail } from '../components/user/GetStartedEmail';
import HomepageStarterEmail from '../components/user/HomepageStarterEmail/HomepageStarterEmail';

/**
 * Get started page
 * @returns {JSX}
 */
const GetStartedEmailPage = () => {
  useAppOriginParam();

  return (
    <>
      {// ! Old design, still dont know if its gonna be removed or if its gonna be a different path
      }
      {/* <Col className="p-0" xs={12} md={6} xl={7}>
        <GetStartedEmail />
      </Col>
      <Col className="p-0 d-none d-md-block" md={6} xl={5}>
        <Ads />
      </Col> */}
      <HomepageStarterEmail />
    </>
  );
};

export default GetStartedEmailPage;